import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    bins: Array
  }

  connect() {
    this.syncAllRows()
  }

  syncAll() {
    this.syncAllRows()
  }

  syncRow(event) {
    const row = event.target.closest("tr")
    if (!row) return

    this.syncOutputRow(row)
  }

  syncAllRows() {
    this.element.querySelectorAll("[data-output-line-row]").forEach((row) => {
      this.syncOutputRow(row)
    })
  }

  syncOutputRow(row) {
    const locationSelect = row.querySelector("[data-output-line-location-select]")
    const binSelect = row.querySelector("[data-output-line-bin-select]")
    if (!locationSelect || !binSelect) return

    const locationId = locationSelect.value
    const selectedBinId = binSelect.value
    const bins = this.availableBinsFor(locationId)

    this.replaceBinOptions(binSelect, bins)

    if (bins.some((bin) => String(bin.id) === String(selectedBinId))) {
      binSelect.value = selectedBinId
    } else {
      binSelect.value = ""
    }
  }

  availableBinsFor(locationId) {
    if (!locationId) return []

    return this.binsValue.filter((bin) => String(bin.location_id) === String(locationId))
  }

  replaceBinOptions(select, bins) {
    const blankLabel = select.dataset.blankLabel || ""

    select.innerHTML = ""
    select.appendChild(new Option(blankLabel, ""))

    bins.forEach((bin) => {
      select.appendChild(new Option(bin.label, bin.id))
    })
  }
}
